import { AGRONOMIST_CARD_ORDER, AgronomistCardId } from "pages/app/home/agronomist/agronomistCards";
import type { AgronomistSignals } from "pages/app/home/agronomist/useAgronomistSignals";

// Terra is never the place to start: the tag guides farmers to SoilSight or the Cover Crop Mixer until they have used it
const START_HERE_CANDIDATES = AGRONOMIST_CARD_ORDER.filter((card) => card !== "terra");

/** whether the farm has used the tool already; undefined while its list has not answered */
const hasUsed = (card: AgronomistCardId, { hasScenarios, hasSavedMix }: AgronomistSignals): boolean | undefined => {
  switch (card) {
    case "soilSight":
      return hasScenarios;
    case "coverCropMixer":
      return hasSavedMix;
    case "terra":
      return true;
    default: {
      const unknownCard: never = card;
      return unknownCard;
    }
  }
};

/**
 * The card to start with: the first candidate rendered that the farm has not used yet. None while a candidate's answer is
 * still open, so the tag never jumps from one card to another once the lists arrive.
 */
export const pickRecommendedCard = (cards: AgronomistCardId[], signals: AgronomistSignals): AgronomistCardId | null => {
  const candidates = START_HERE_CANDIDATES.filter((card) => cards.includes(card));
  for (const card of candidates) {
    const used = hasUsed(card, signals);
    if (used === undefined) return null;
    if (!used) return card;
  }
  return null;
};
